import { IDateRange } from "../services/date-range";
import { IContentStream, IUser } from "../types";
import state from "./store";
import sortBy from 'lodash/sortBy';

/**
 * Save added splits
*/
export const saveSplits = (newSplit: any): void => {
  const splits = state.get('sessionSplits') || {};
  const userSplits: any = {...splits, newSplit};
  state.set('sessionSplits', userSplits);
}

/**
 * Save user to state
 * @param user is the user object
 */
export const saveUser = (user: IUser): void => state.set('user', user);

/**
 * Save global data range. Content stream date range
 * superceeds global date range. @see {@link saveStreamDateRange}
 * @param dateRange is the date range object.
 */
export const saveGlobalDateRange = (dateRange: IDateRange): void => state.set('globalDateRange', dateRange);

/**
 * Save date range on individual content stream. If not set
 * the global date range will override. @see {@link saveGlobalDateRange}
 * @param dateRange is the date range object.
 * @param streamIndex is the stream index to be updated.
 */
export const saveStreamDateRange = (dateRange: IDateRange, streamIndex: number): void => {
  const streams = state.get('contentStreams');
  const updatedStreams = streams.map((stream, index) => {
    if (index === streamIndex) {
      stream.dateRange = dateRange;
    }
    return stream;
  });
  state.set('contentStreams', updatedStreams);
}

/**
 * Save various search data to state. Search data type can be
 * one of `misearch` | `rss`| `tag`| `news`| `broadcast`| `social`| 'mediaList' | 'authorList'
 * @param data is the search data grouped by type;
 */
export const saveSearches = (data): void => { Object.keys(data).forEach((key: 'misearch' | 'tag' | 'rss' | 'mediaList' | 'authorList' | 'combinedList') => {
  state.set(key, sortBy(data[key], [i => i.name.toLowerCase()]));
})};

/**
 * Persist selected streams.
 * @param contentStream is list of content stream objects.
 */
 export const saveContentStreamState = (contentStream: IContentStream[]): void => {
  state.set('contentStreams', contentStream);
 }

/**
 * Save content stream data.
 * @param stream is the content stream object.
 */
// TODO: updated to content stream.
export const addContentStream = (stream: IContentStream): void => {
  const currStreams = state.get('contentStreams');
  const updatedStreams = [ ...currStreams, stream ];
  state.set('contentStreams', updatedStreams);
}

export const updateContentStream = (stream: IContentStream, streamIndex: number): void => {
  const currStreams = state.get('contentStreams');
  const updatedStreams = currStreams.map((currStream, index) => {
    if (index === streamIndex) {
      return stream;
    }
    return currStream;
  });

  state.set('contentStreamsUpdated', !state.get('contentStreamsUpdated'))
  state.set('contentStreams', updatedStreams);
}

export const removeContentStream = (stream: IContentStream): void => {
  const currStreams = state.get('contentStreams');
  let updatedStreams = currStreams.filter((s) => s.tempId !== stream.tempId);
  state.set('contentStreams', updatedStreams);
}

export const removeAllContentStream = (): void => {
  state.set('contentStreams', []);
}
